var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"global-modal"},[(_vm.component === 'Library')?_c('Library',{attrs:{"params":_vm.params,"isModal":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }